module.exports = __webpack_public_path__ + "static/media/header.9baa2e04.png";